import React from "react";
import { Link } from "react-router-dom";
type LogoProps = {
  light?: boolean;
};
export function Logo({
  light = false
}: LogoProps) {
  const color = light ? "text-cream" : "text-navy";
  return <Link to="/" className={`flex items-center gap-2.5 ${color}`} aria-label="Mieussy 2028 — accueil" data-id="element-166" data-mp="3qa33id2hkd2q">
      <svg width="34" height="22" viewBox="0 0 34 22" fill="none" aria-hidden="true" data-id="element-167" data-mp="3v7wcfdv6bl6p">
        <path d="M2 9C7 2.5 27 2.5 32 9" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" data-id="element-168" data-mp="mscmanpsuivv" />
        <path d="M5 9.5L17 20M29 9.5L17 20M17 5v15" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" data-id="element-169" data-mp="rsh36eumdfmm" />
      </svg>
      <span className="font-serif text-2xl leading-none" data-id="element-170" data-mp="dregq0zpq3b6">
        Mieussy <span className="italic" data-id="element-171" data-mp="ht8cpvyyqj50">2028</span>
      </span>
    </Link>;
}